import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { Title } from '@angular/platform-browser';

import { IconSetService } from '@coreui/icons-angular';
import { iconSubset } from './icons/icon-subset';
import { IdleService } from './idle.service';

@Component({
  selector: 'app-root',
  template: '<router-outlet />',
  standalone: true,
  imports: [RouterOutlet],
})
export class AppComponent implements OnInit {
  title = 'x2x Licensing Portal';

  constructor(
    private router: Router,
    private titleService: Title,
    private iconSetService: IconSetService,
    private idleService: IdleService
  ) {
    this.titleService.setTitle(this.title);
    this.iconSetService.icons = { ...iconSubset };
  }

  ngOnInit(): void {
    // Check if session has expired on app initialization
    // const sessionExpiry = localStorage.getItem('sessionExpiry');
    // if (sessionExpiry && Date.now() > parseInt(sessionExpiry)) {
    //   localStorage.clear();
    //   this.router.navigate(['/login']);
    //   return;
    // }

    // Start idle watcher if session is still valid
    // this.idleService.startWatching();
  }
}